import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChatHeaderBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  height: 60,
  boxSizing: 'border-box',
  paddingLeft: 10,
  backgroundColor: theme.palette.grey[50],
  boxShadow: theme.customShadows?.card ?? 'none',
}));
